<template>
  <div class="user-reapet-table-wrapper">
    <el-table :data="tableData">
      <el-table-column property="contactName" label="联系人">
        <template slot-scope="scope">
          <span class="text-split" :title="scope.row.name">{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column property="contactTelephoneNo" label="联系电话">
        <template slot-scope="scope">
          <span class="text-split" :title="scope.row.telephoneNo">{{scope.row.telephoneNo}}</span>
        </template>
      </el-table-column>
      <el-table-column property="ownerName" label="跟进人">
        <template slot-scope="scope">
          <span
            class="text-split"
            :title="scope.row.ownerName"
          >{{scope.row.ownerName !== "" ? scope.row.ownerName : "暂无"}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="followUpStatusName" align="center" label="跟进状态">
        <template slot-scope="scope">
          <span
            class="text-split"
            :title="scope.row.followUpStatusName"
          >{{scope.row.followUpStatusName !== "" ? scope.row.followUpStatusName : "暂无"}}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    userPhone: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      tableData: []
    };
  },
  created() {
    this.getReapetUser();
  },
  watch: {
    userPhone() {
      this.getReapetUser();
    }
  },
  methods: {
    getReapetUser() {
      this.$api
        .get(`/merchants`, {
          params: {
            page: 0,
            size: 500,
            telephoneNo: this.userPhone
          }
        })
        .then(res => {
          if (res.status === 200 || res.status === 206) {
            let { content, totalPages, totalElements, last } = res.data;
            this.tableData = content;
          }
        })
        .catch(err => {
          this.tableLoading = false;
          console.error(err);
          this.$message.error(err.message);
        });
    },
    showClient(target) {
      this.$router.push({
        path: "/merchants/detail",
        query: {
          id: target.id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.user-reapet-table-wrapper {
  box-sizing: border-box;
  width: 100%;
}
</style>